// src/prototype/components/EffortTagPill.tsx
// Effort tag shown on explorer rows and the brief header.
import React from 'react';
import type { EffortTag } from '../data/decisionBrief';

export interface EffortTagPillProps {
  tag: EffortTag;
}

export const EffortTagPill: React.FC<EffortTagPillProps> = ({ tag }) => (
  <span
    className={`text-[10px] font-semibold px-2 py-0.5 rounded border ${
      tag === 'Quick Win'
        ? 'bg-green-50 text-green-700 border-green-200'
        : 'bg-amber-50 text-amber-700 border-amber-200'
    }`}
  >
    {tag}
  </span>
);

export default EffortTagPill;
